export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=406bbe9cd7e811ebacf01bc10dbd24cfd1b11676e0&name=revalidateCommunity!'